import { render } from "./back.vue?vue&type=template&id=4c700275&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import "./back.vue?vue&type=style&index=0&id=4c700275&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c700275"

export default script